export function timeAgo(dateString?: string | null): string {
	if (!dateString) return ''
	const days = Math.round((Date.now() - new Date(dateString).getTime()) / 864e5)
	if (days <= 0) return 'today'
	if (days === 1) return 'yesterday'
	if (days < 7) return `${days}d ago`
	if (days < 30) return `${Math.round(days / 7)}w ago`
	return `${Math.round(days / 30)}mo ago`
}
